module.exports = __webpack_public_path__ + "static/media/twitter.0fc245b5.svg";